<ppl-popover-dropdown>
  <ppl-menu [value]="value"
            [hasIcons]="false"
            (valueChanged)="valueChange.emit($event)">
    <ppl-menu-item *ngFor="let option of options"
                   [value]="option.id"
                   pplPopoverClose>
      {{ option.label }}
    </ppl-menu-item>
  </ppl-menu>
</ppl-popover-dropdown>